/*
 * Klaviyo teaser — hide while the cart drawer is open or the sticky
 * cart-bar is on screen.
 *
 * Klaviyo mounts its teaser inside a fixed-position wrapper with
 * inline `z-index: 90000`, which otherwise sits above the cart drawer
 * (z-index 6001) and cart-bar. Toggle a class on <html>, let CSS use
 * !important to beat Klaviyo's inline styles, and let the class
 * survive if Klaviyo remounts the DOM.
 */
(function () {
  const HIDE_CLASS = 'klaviyo-teaser-is-hidden';
  const root = document.documentElement;

  let cartDrawerOpen = false;
  let cartBarOnScreen = false;
  let teaserHidden = false;

  function syncTeaser() {
    const shouldHide = cartDrawerOpen || cartBarOnScreen;
    if (shouldHide === teaserHidden) return;
    teaserHidden = shouldHide;
    root.classList.toggle(HIDE_CLASS, shouldHide);
  }

  document.addEventListener('theme:cart-drawer:open', () => {
    cartDrawerOpen = true;
    syncTeaser();
  });
  document.addEventListener('theme:cart-drawer:close', () => {
    cartDrawerOpen = false;
    syncTeaser();
  });

  const productForm = document.querySelector('[data-product-form]');
  if (productForm && document.querySelector('cart-bar') && typeof IntersectionObserver !== 'undefined') {
    new IntersectionObserver(
      (entries) => {
        cartBarOnScreen = !entries[0].isIntersecting;
        syncTeaser();
      },
      { threshold: 0 }
    ).observe(productForm);
  }
})();
